import { StyledMainSpecialists } from '@/components/styles'
import { PartitionCard } from '@/components'
import genLinkParams from '@/lib/generateLinkParams'

export default function MainSpecialists({ specialists }) {
  return (
    <StyledMainSpecialists>
      {specialists.map((specialist, ind) => {
        const {
          id,
          preview,
          position,
          qualification,
          slug,
          first_name: firstName,
          last_name: lastName,
        } = specialist
        const [href, as] = genLinkParams({
          type: 'specialist',
          slug,
        })
        const title = `${lastName} ${firstName}`
        return (
          <StyledMainSpecialists.Item key={`specialist-${id}`}>
            <PartitionCard
              image={preview}
              title={title}
              desc={position}
              link={{ href, as }}
              text={qualification}
              cardType="specialist"
            />
          </StyledMainSpecialists.Item>
        )
      })}
    </StyledMainSpecialists>
  )
}
